import { ChangeDetectorRef, Component, ViewChild, ViewRef } from '@angular/core';
import { MatSort, MatSortModule, Sort } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import _ from 'lodash';
import { ResponsiveService } from '../../../../services/responsive.service';
import { ApiQuery } from '../../../../web-services/api/api.query';
import { ApiService } from '../../../../web-services/api/api.service';
import { ApiStore } from '../../../../web-services/api/api.store';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Snackbar } from '../../../snackbar/snackbar';
import { CustomSnackbar } from '../../../custom-snackbar/custom-snackbar';
import { MatDialog } from '@angular/material/dialog';
import { TranslatorService } from '../../../../services/translator_service';
import { UtilService } from '../../../../services/util.service';
import { takeUntil } from 'rxjs/operators';
import { combineLatest, Subject } from 'rxjs';
import { SelectionModel } from '@angular/cdk/collections';
import { BinLiveInfoModal } from '../../../bin-live-info-modal/bin-live-info-modal';
import { DeleteEventsModal } from '../delete-events-modal/delete-events-modal';
import { UndoDeleteEvents } from '../undo-delete-events/undo-delete-events';
import { AcceptEventsModal } from '../accept-events-modal/accept-events-modal';
import { CollectionClusterInfoModal } from '../../collection-cluster-info-modal/collection-cluster-info-modal';
import { AddCollectionModal } from '../add-collection-modal/add-collection-modal';
import { TableUtil } from '../../../../tableUtil';
import moment from 'moment';
import { RTLDivDirectiveDirective } from '../../../../directives/rtldiv-directive.directive';
import { MatDividerModule } from '@angular/material/divider';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatMenuModule } from '@angular/material/menu';
import { FormsModule } from '@angular/forms';
import { Pagination } from '../../../pagination/pagination';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-analyze-collections-table',
  imports: [TranslatePipe, RTLDivDirectiveDirective, MatDividerModule, MatCardModule,CommonModule,MatCheckboxModule,
    MatTableModule,MatSortModule,MatMenuModule,FormsModule,Pagination,RouterModule],
  templateUrl: './analyze-collections-table.html',
  styleUrl: './analyze-collections-table.scss',
})
export class AnalyzeCollectionsTable {
  currentLang;
	translationsObj;
  isMobile: boolean;
  usageType = 1;
	user_role_id = 0;
  tempFilter = '';
  groupsWithCollections:any;
  groups:any[]=[];
  groupsBackup:any[]=[]
  dataSource = new MatTableDataSource<any>();
  filteredData:Array<object> = [];
  startIndexTableData = 0;
  endIndexTableData = 9;
  @ViewChild(MatSort,{static: false}) sort: MatSort;
  clusterBins: Array<any> = [];
  spinnerActive:boolean = true;
  binsBackUp: Array<any> = [];
  capacityDisplayType: number = 0;
  registeredCollection:boolean = false;
  suspiciousCollection:boolean = true;
  invalidCollection:boolean = false;
  removedCollection:boolean = false;
  capacityDisplaySymbol: string = '%';
  displayedColumns = ['select','name','evType','siteName', 'address','clearing','arrival_time','cause','suspicion_reason','removed_reason','removed_by','removed_date','capacity_before','capacity_after','collection_mode','manage'];
  selection = new SelectionModel<Element>(true, []);
  suspiciousCollectionLength = 0;
  invalidCollectionLength = 0;
  registeredCollectionLength = 0;
  removedCollectionLength = 0;
	private readonly destroy$ = new Subject<void>();
  private isAcceptingItem: boolean = false;

  constructor(private translator: TranslatorService,private responsiveService: ResponsiveService,private apiQuery:ApiQuery,
    private utilService: UtilService,private dialog: MatDialog,private apiService:ApiService,private cd: ChangeDetectorRef,
    private apiStore:ApiStore,private snackBar: MatSnackBar) {
      this.translator.currentLangEmitter$
      .subscribe(async value=>{						
        this.translationsObj = await this.translator.getTranslation(value).toPromise()			 
        this.currentLang = value;	
      });
  }

  ngOnInit() {   
    this.onResize();
    this.responsiveService.checkWidth();
    this.spinnerActive = true;	

    this.apiQuery.user$.subscribe(user => {
			if (!user) return;
      this.capacityDisplayType = user["user_default_capacity_type_id"];
			if(user["usage_type_id"] != 1){
				this.usageType = user["usage_type_id"];
			}
      this.user_role_id = user["user_role_id"];
		});

    combineLatest([
      this.apiQuery.removedCollectionsStats$,
      this.apiQuery.unApprovedAndDeletedSuspectedAsCollectionEvents$,
      this.apiQuery.collectionsStatsInCollections$,
      this.apiQuery.filteredBins$,
      this.apiQuery.sitesClustersList$])
      .pipe(takeUntil(this.destroy$))
      .subscribe(([removedCollectionsStats,unApprovedAndDeletedSuspectedAsCollectionEvents,data,bins,clusters])=>{
        this.selection.clear();
        this.spinnerActive = true;		
        this.cd.detectChanges();
        if(data.length == 0 || removedCollectionsStats.length == 0) return;    
        this.removeFilter();
        this.groups = [];
        if (!_.isEmpty(data[0])){
          _.each(data, (site) => {
            if(site['site_bins_collections'] != undefined){
              _.each(site['site_bins_collections']["0_25"], (item) => {    
                item.site_name = site['site_name'];   
                item.site_id = site['site_id'];   
                this.groups.push(item);
              });    
              _.each(site['site_bins_collections']["26_50"], (item) => {   
                item.site_name = site['site_name'];
                item.site_id = site['site_id'];             
                this.groups.push(item);
              });
              _.each(site['site_bins_collections']["51_75"], (item) => {     
                item.site_name = site['site_name'];
                item.site_id = site['site_id'];           
                this.groups.push(item);
              });
              _.each(site['site_bins_collections']["76_85"], (item) => {          
                item.site_name = site['site_name'];
                item.site_id = site['site_id'];      
                this.groups.push(item);
              });
              _.each(site['site_bins_collections']["86_100"], (item) => {         
                item.site_name = site['site_name'];
                item.site_id = site['site_id'];       
                this.groups.push(item);
              });
            }
          });
        }
        if(!_.isEmpty(removedCollectionsStats[0])){
          _.each(removedCollectionsStats, (site) => {    
            _.each(site['site_collections'], (item) => {    
              _.each(item['bin_collections'], (collection) => {    
                collection.site_name = site['site_name'];
                collection.site_id = site['site_id'];       
                collection.bin_id = item['bin_id'];
                collection.bin_name = item['bin_name'];
                collection.bin_address = item['bin_address'];
                this.groups.push(collection);
              }); 
            }); 
          }); 
        }

        if(!_.isEmpty(unApprovedAndDeletedSuspectedAsCollectionEvents[0])){
          _.each(unApprovedAndDeletedSuspectedAsCollectionEvents, (site) => {    
            _.each(site['site_collections'], (item) => {    
              _.each(item['bin_collections'], (collection) => {    
                collection.site_name = site['site_name'];
                collection.site_id = site['site_id'];       
                collection.bin_id = item['bin_id'];
                collection.bin_name = item['bin_name'];
                collection.bin_address = item['bin_address'];
                this.groups.push(collection);
              }); 
            }); 
          }); 
        }

        this.groupsBackup = this.groups;
        if (bins.length == 0) return;
        this.spinnerActive = false;
        this.binsBackUp = bins;
        _.each(_.groupBy(this.binsBackUp,(item) => `${item.cluster_id},${item.site_id}`), (clusters) => {
            let cluster_avg = 0;
            _.each(clusters, (bin) => {
              if (this.capacityDisplayType != 0) {
                cluster_avg += (bin["Bin_live_Data"].fill_level_percent * bin["Bin_thresholds"].bin_max_capacity_in_liters) / 100;
              } else {
                cluster_avg += bin["Bin_live_Data"].fill_level_percent;
              }
            });
            _.each(clusters, (bin) => {
              bin["cluster_avg"] = cluster_avg / clusters.length;
              bin["number_of_bins_in_cluster"] = clusters.length;
            });
          }
        );
        _.each(this.groups, (item) => {
          let relevantBin = this.binsBackUp.filter(
            (bin) =>
              bin["site_id"] == item.site_id &&
              bin["cluster_id"] == item.cluster_id &&
              bin["bin_id"] == item.bin_id
          );
          let chosenCluster = clusters.filter(
            (cluster) =>
              cluster["site_id"] == item.site_id &&
              cluster["cluster_id"] == item.cluster_id
          );

          if (relevantBin.length > 0) {
            item["cluster_avg"] = relevantBin[0]["cluster_avg"];
            item["number_of_bins_in_cluster"] = relevantBin[0]["number_of_bins_in_cluster"];
          }

          if (chosenCluster.length > 0) {
            item["chosenCluster"] = chosenCluster[0];

            let binsInCluster = this.binsBackUp.filter(
              (bin) =>
                bin["site_id"] == chosenCluster[0]["site_id"] &&
                bin["cluster_id"] == chosenCluster[0]["cluster_id"]
            );
            let collection_rate = 0;
            let avg_collection_rate = 0;
            _.each(binsInCluster, (bin) => {
              collection_rate += bin["Bin_live_Data"].bin_collection_or_refill_rate;
            });
            avg_collection_rate = collection_rate / binsInCluster.length;
            item["chosenCluster"]["avg_collection_rate"] = avg_collection_rate;
          }
        });
        this.spinnerActive = false;	
        this.suspiciousCollectionLength = this.groups.filter((item) => item["is_suspected_collection"] == 1).length;
        this.registeredCollectionLength = this.groups.filter((item) => item["is_suspected_collection"] == 0).length;
        this.invalidCollectionLength = this.groups.filter((item) => item["is_approved_suspected_as_collection_event"] == false && item["is_deleted_suspected_as_collection_event"] != true).length;
        this.removedCollectionLength = this.groups.filter((item) => item["is_suspected_collection"] == null && item["is_suspected_as_collection_event"] == null).length;

        if(this.suspiciousCollectionLength == 0){
          this.suspiciousCollection = false;
        }else{
          this.suspiciousCollection = true;
        }

        this.applyState();
      });
  }

  onResize() {
    this.responsiveService.getMobileStatus().subscribe(isMobile => {
      this.isMobile = isMobile;
    });
  }

  ngOnDestroy(){
		this.destroy$.next();
		this.destroy$.complete();
		if (!(this.cd as ViewRef).destroyed) {			
			this.cd.detectChanges();
		}
	}

  openElementBinInfo(el) {
		let class_name = '';
		let selectedElements = [];
		if(this.isMobile){
			class_name = 'popup-container-mobile';
		}else{
			class_name = this.currentLang != "iw" ? "clusterInfo-container-ltr" : "clusterInfo-container-rtl";
		}

		selectedElements = [el];

		// Check if dialog is already open (using static property for cross-page support)
		if(BinLiveInfoModal.openModalRef && BinLiveInfoModal.openModalRef.componentInstance && !BinLiveInfoModal.openModalRef.componentInstance.dialogRef.closed) {
			// Dialog is already open, add tabs to existing modal
			BinLiveInfoModal.openModalRef.componentInstance.addTabs(selectedElements);
			return;
		}

		const dialogRef = this.dialog.open(BinLiveInfoModal, {
			panelClass: class_name,
			width: '55%',
			data: {
			  item: selectedElements
			},
		});

		// Set static reference for cross-page access
		BinLiveInfoModal.openModalRef = dialogRef;

		// Clear reference when dialog is closed
		dialogRef.afterClosed().subscribe(() => {
			BinLiveInfoModal.openModalRef = null;
		});
	}

  applyState(status?){    
    if(status){
      this.selection.clear();
      if(status == 'registered'){
        if(this.registeredCollectionLength == 0){
          return;
        }
        this.registeredCollection = !this.registeredCollection;
      }else if(status == 'suspicious'){
        if(this.suspiciousCollectionLength == 0){
          return;
        }
        this.suspiciousCollection = !this.suspiciousCollection;
      }else if(status == 'removed'){
        if(this.removedCollectionLength == 0){
          return;
        }
        this.removedCollection = !this.removedCollection;
      }else if(status == 'invalid'){
        if(this.invalidCollectionLength == 0){
          return;
        }
        this.invalidCollection = !this.invalidCollection;
      }
    }

    const activeFilters: Array<(item: any) => boolean> = [];

    if (this.registeredCollection) {
      activeFilters.push((item) => item.is_suspected_collection == 0);
    }
    if (this.suspiciousCollection) {
      activeFilters.push((item) => item.is_suspected_collection == 1);
    }
    if (this.removedCollection) {
      activeFilters.push((item) => item.is_suspected_collection == null && item.is_suspected_as_collection_event == null);
    }
    if (this.invalidCollection) {
      activeFilters.push((item) => item.is_approved_suspected_as_collection_event == false && item.is_deleted_suspected_as_collection_event != true);
    }

    if (activeFilters.length === 0) {
      this.groups = [];
    } else {
      this.groups = _.filter(this.groupsBackup, (item) => activeFilters.some(fn => fn(item)));
    }
    this.initTableData(this.groups);
  }

  isRemovedCollectionEnabled(): boolean {
    return this.removedCollection;
  }

  isSuspiciousCollectionEnabled(): boolean {
    return this.suspiciousCollection || this.invalidCollection;
  }

  masterToggle = () => {
		this.isAllSelected() ?
			this.selection.clear() :
			this.dataSource["AllData"].filteredData.map((row:any) =>
				this.selection.select(row))
	}

  isAllSelected = (): boolean => {
		const numSelected = this.selection.selected.length;
		const numRows = this.dataSource["AllData"].filteredData.length;
		return numSelected === numRows;
	}

  isAllSuspected(): boolean {
    return this.selection.selected.length > 0 &&
           this.selection.selected.every(item => item['is_suspected_collection'] == 1 || (item['is_approved_suspected_as_collection_event'] == false && item['is_deleted_suspected_as_collection_event'] != true));
  }

  isAllNotRemoved(): boolean {
    return this.selection.selected.length > 0 &&
           this.selection.selected.every(item => (item['is_suspected_collection'] != null || item['is_suspected_as_collection_event'] != null) && item['is_deleted_suspected_as_collection_event'] != true);
  }

  isAllRemoved(): boolean {
    return this.selection.selected.length > 0 &&
           this.selection.selected.every(item => item['is_suspected_collection'] == null && item['is_suspected_as_collection_event'] == null);
  }

  applyFilter = (filterValue: any) => {
    filterValue = filterValue.value;
    filterValue = filterValue.trim();
		filterValue = filterValue.toLowerCase();
		this.tempFilter = filterValue;
		this.updateTableData();
    setTimeout(() => {
      this.cd.detectChanges();
    }, 0);
  }

  private updateTableData(): void {
    const tableData = [];
    const tempSearch = new MatTableDataSource<any>(this.groupsWithCollections || []);
    tempSearch.filter = this.tempFilter;
    this.filteredData = tempSearch.filteredData;
    for (let index = this.startIndexTableData; index <= this.endIndexTableData; index++) {
      if (tempSearch.filteredData[index]) {
        tableData.push(tempSearch.filteredData[index]);
      }
    }
    this.dataSource = tableData.length > 0 ? new MatTableDataSource<any>(tableData) : new MatTableDataSource<any>([]);
    this.dataSource["AllData"] = new MatTableDataSource<any>(tempSearch.filteredData);		
  }

  sortData(sort: Sort) {    
    const data = this.groupsWithCollections.slice();    
    if (!sort.active || sort.direction === '') {
      this.groupsWithCollections = data;
      this.updateTableData();
      return;
    }
    this.groupsWithCollections = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      return sort.active ? this.compare(this.getSortValue(a, sort.active), this.getSortValue(b, sort.active), isAsc) : 0;
    });
    this.updateTableData();
  }

  private getSortValue(item: any, column: string) {
    switch (column) {
      case 'is_suspected_collection':
        return this.translationsObj ? this.getEventTypeLabel(item) : item[column];
      case 'suspicion_reason':
        return (this.currentLang != 'iw' ? item.suspected_reason_name_for_suspicious_collection : item.suspected_reason_name_for_suspicious_collection_hebrew) ?? '';
      case 'removed_reason':
        return (this.currentLang != 'iw' ? item.suspected_reason_name : item.suspected_reason_name_hebrew) ?? '';
      default:
        return item[column];
    }
  }

  compare(a, b, isAsc) {
		return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  private isSuspectedAsRealOnly(items: Array<any>): boolean {
    return items.length > 0 && items.every((item: any) =>
      item['is_approved_suspected_as_collection_event'] == false);
  }

  private deleteCollections(items: Array<any>) {
    let undo_clicked = false;
    const snackBarRef = this.snackBar.openFromComponent(CustomSnackbar,
		  {
        data: {events: items, action: 'delete'},
        panelClass: 'custom-toast-class',
        horizontalPosition: this.currentLang != 'iw' ? 'left' : 'right',
        verticalPosition: 'bottom',
        duration: 5000
		  }		
		);

    snackBarRef.onAction().subscribe(() => {
      undo_clicked = true;
      return;
    });

    snackBarRef.afterDismissed().subscribe(info => {
      if (!info.dismissedByAction) {
        if(!undo_clicked){
          let insertRequest = {
            collection_status: 3,
          };
      
          let collectionsIDs = [];
          let transactionsInfo = [];
          _.each(items, (item) => {
            if (item.is_approved_suspected_as_collection_event == false && (item.collection_id == 0 || item.collection_id == null)) {
              transactionsInfo.push({ transaction_id: item.transaction_id, after_collection_transaction_id: item.after_collection_transaction_id });
            } else {
              collectionsIDs.push([Number(item.collection_id), Number(item.suspected_collections_reason_id)]);
            }
          });

          if (transactionsInfo.length > 0) {
            let transactionsInfoRequest = {
              transactions_info: transactionsInfo,
              collection_status: 3
            };
            this.runBulkCollectionUpdate(transactionsInfoRequest, () => {
              let request = {
                site_id_list : JSON.parse(sessionStorage.getItem("chosenSites")).filter(site => site.hasOwnProperty('site_id')).map(site => site.site_id),
                start_date : sessionStorage.getItem("collectionsMinDate"),
                end_date : sessionStorage.getItem("collectionsMaxDate")
              }
              let removedCollectionsStatsRequest = {
                site_id_list : JSON.parse(sessionStorage.getItem("chosenSites")).filter(site => site.hasOwnProperty('site_id')).map(site => site.site_id),
                start_date : sessionStorage.getItem("collectionsMinDate"),
                end_date : sessionStorage.getItem("collectionsMaxDate")
              }
              this.apiStore.update({ allCollectionsStats: [] });
              this.apiStore.update({ collectionsStatsInCollections: [] });
              this.apiService.getfilteredBinsCollectionsStats(request, 5, JSON.parse(sessionStorage.getItem("chosenSites")));
              this.apiService.RemovedSuspectedCollections(removedCollectionsStatsRequest);
              this.apiService.getUnApprovedAndDeletedSuspectedAsCollectionEvents(removedCollectionsStatsRequest);
            });
          }

          if (collectionsIDs.length > 0) {
            insertRequest["collection_id_list"] = collectionsIDs;
            this.runBulkCollectionUpdate(insertRequest, () => {
              let request = {
                site_id_list : JSON.parse(sessionStorage.getItem("chosenSites")).filter(site => site.hasOwnProperty('site_id')).map(site => site.site_id),
                start_date : sessionStorage.getItem("collectionsMinDate"),
                end_date : sessionStorage.getItem("collectionsMaxDate")
              }
              let removedCollectionsStatsRequest = {
                site_id_list : JSON.parse(sessionStorage.getItem("chosenSites")).filter(site => site.hasOwnProperty('site_id')).map(site => site.site_id),
                start_date : sessionStorage.getItem("collectionsMinDate"),
                end_date : sessionStorage.getItem("collectionsMaxDate")
              }
              this.apiStore.update({ allCollectionsStats: [] });
              this.apiStore.update({ collectionsStatsInCollections: [] });
              this.apiService.getfilteredBinsCollectionsStats(request, 5, JSON.parse(sessionStorage.getItem("chosenSites")));
              this.apiService.RemovedSuspectedCollections(removedCollectionsStatsRequest);
              this.apiService.getUnApprovedAndDeletedSuspectedAsCollectionEvents(removedCollectionsStatsRequest);
            });
          }
        }
      }
    });
  }

  private runBulkCollectionUpdate(requestBody: any, afterVerify: () => void) {
    this.apiService.GenerateCollectionUpdateToken().subscribe({
      next: (tokenResponse: any) => {
        const token = tokenResponse?.token ?? 0;
        const bodyWithToken = { ...requestBody, token };
        this.apiService.insertCollectionParams(bodyWithToken).subscribe({
          next: (response: any) => {
            this.apiService.VerifyCollectionUpdateTaskStatusByToken({ token }).subscribe({
              next: (statusResponse: any) => {
                const statusList = statusResponse?.collectionUpdateTaskStatus?.collectionDataUpdateStatus || [];
                const allFinished = statusList.every((item: any) => item.is_executed == 1 && item.is_finished == 1);
                if (allFinished) {
                  this.openResultSnackbar('completed');
                } else {
                  const failedItems = statusList.filter((item: any) => !(item.is_executed == 1 && item.is_finished == 1));
                  this.openResultSnackbar('failed', failedItems);
                }
                afterVerify();
              },
              error: (err) => {
                console.error('Failed to verify collection update task status:', err);
                this.openResultSnackbar('failed');
                afterVerify();
              }
            });
          },
          error: (err) => {
            console.error('Failed to insert collection params:', err);
            this.openResultSnackbar('failed');
          }
        });
      },
      error: (err) => {
        console.error('Failed to generate collection update token:', err);
        this.openResultSnackbar('failed');
      }
    });
  }

  private openResultSnackbar(result: 'completed' | 'failed', failedItems: any[] = []) {
    this.snackBar.openFromComponent(Snackbar, {
      data: { popup: 'collectionResult', result: result, action: 'delete', error_messages: failedItems || [] },
      panelClass: 'custom-snackbar-class'
    });
  }

  isRemovedCollection(item): boolean {
    return item != null && item['is_suspected_collection'] == null && item['is_suspected_as_collection_event'] == null;
  }

  undoDeleteItem = (item) => {
    if(!this.isRemovedCollection(item)){
      return;
    }
    this.dialog.open(UndoDeleteEvents, { panelClass: 'bulkBins-container' , data: {items : [item]} });
  }

  deleteItem = (item) => {
    const items = [item];
    if(this.isSuspectedAsRealOnly(items)){
      this.deleteCollections(items);
      return;
    }
    this.dialog.open(DeleteEventsModal, { panelClass: 'bulkBins-container' , data: {items : items} });    
  }

  duplicateItem = (item) => {
    // let request = {};
    // this.apiService.insertCollectionParams(request).subscribe((v:any) => {

    // });
  }

  acceptItem = (item) => {
    if (this.isAcceptingItem) return;
    
    this.isAcceptingItem = true;
    if (item.is_approved_suspected_as_collection_event == false && (item.collection_id == 0 || item.collection_id == null)) {
      let insertRequest = {
        transactions_info: [{ transaction_id: item.transaction_id, after_collection_transaction_id: item.after_collection_transaction_id }],
        collection_status: 1
      };
      this.apiService.insertCollectionParams(insertRequest).subscribe({
        next: (v: any) => {
          this.groupsBackup = this.groupsBackup.map(group => {
            if (group.transaction_id == item.transaction_id) {
              group.is_suspected_collection = 0;
              group.is_approved_suspected_as_collection_event = true;
            }
            return group;
          });
          this.registeredCollectionLength = this.groupsBackup.filter((item) => item["is_suspected_collection"] == 0).length;
          this.suspiciousCollectionLength = this.groupsBackup.filter((item) => item["is_suspected_collection"] == 1).length;
          this.removedCollectionLength = this.groupsBackup.filter((item) => item["is_suspected_collection"] == null && item["is_suspected_as_collection_event"] == null).length;
          this.invalidCollectionLength = this.groupsBackup.filter((item) => item["is_approved_suspected_as_collection_event"] == false && item["is_deleted_suspected_as_collection_event"] != true).length;

          this.selection.clear();
          this.applyState();
        },
        error: (error) => {
          console.error('Error updating collection status:', error);
        },
        complete: () => {
          this.isAcceptingItem = false;
        }
      });
    } else {
      let insertRequest = {
        collection_status:1,
        collection_id_list: [[Number(item.collection_id),0]]
      };
      this.apiService.insertCollectionParams(insertRequest).subscribe({
        next: (v:any) => {
          let approveRequest = {
            suspected_collection_id_list: [item.collection_id]
          };
          this.apiService.approveSuspectedCollection(approveRequest).subscribe({
            next: (v:any) => {
              this.groupsBackup = this.groupsBackup.map(group => {
                if(group.collection_id == item.collection_id){
                  group.is_suspected_collection = 0;
                  group.is_approved_suspected_as_collection_event = true;
                }
                return group;
              });
              this.registeredCollectionLength = this.groupsBackup.filter((item) => item["is_suspected_collection"] == 0).length;
              this.suspiciousCollectionLength = this.groupsBackup.filter((item) => item["is_suspected_collection"] == 1).length;
              this.removedCollectionLength = this.groupsBackup.filter((item) => item["is_suspected_collection"] == null && item["is_suspected_as_collection_event"] == null).length;
              this.invalidCollectionLength = this.groupsBackup.filter((item) => item["is_approved_suspected_as_collection_event"] == false && item["is_deleted_suspected_as_collection_event"] != true).length;

              this.selection.clear();
              this.applyState();
            },
            error: (error) => {
              console.error('Error approving suspected collection:', error);
            }
          });
        },
        error: (error) => {
          console.error('Error updating collection status:', error);
        },
        complete: () => {
          this.isAcceptingItem = false;
        }
      });
    }
  }

  deleteBulkItems = () => {
    if(this.selection.selected.length < 2){
      return;
    }
    if(this.isSuspectedAsRealOnly(this.selection.selected)){
      this.deleteCollections(this.selection.selected);
      return;
    }
    this.dialog.open(DeleteEventsModal, { panelClass: 'bulkBins-container' , data: {items : this.selection.selected} });
  }

  undoBulkDelete = () => {
    if(this.selection.selected.length < 2){
      return;
    }
    this.dialog.open(UndoDeleteEvents, { panelClass: 'bulkBins-container' , data: {items : this.selection.selected} });
  }

  acceptBulkItems = () => {
    if(this.selection.selected.length < 2){
      return;
    }
    this.dialog.open(AcceptEventsModal, { panelClass: 'bulkBins-container' , data: {items : this.selection.selected} }); 
  }

  getImg(value:any){			
		if(value){
			return "assets/images/reports/workplan-included.svg";
		}else{
			return "assets/images/reports/workplan-not-included.svg";
		}
	}

  initTableData(groups){
    this.groupsWithCollections = this.getArrayOfCollections(groups);
    this.dataSource = new MatTableDataSource<any>(this.groupsWithCollections);      
    this.dataSource.sort = this.sort;
    this.sortData({ direction: 'desc', active: 'bin_name' });
    this.cd.detectChanges();
  }

  openClusterInfo(el) {
    this.clusterBins = [];
    let capacityAnalysisBins = this.groupsWithCollections.filter((bin) => bin["site_id"] == el.site_id && bin["cluster_id"] == el.cluster_id);
    let binsInfoSameCluster = this.binsBackUp.filter((bin) =>
        bin["site_id"] == el.site_id && bin["cluster_id"] == el.cluster_id
    );

    _.each(binsInfoSameCluster, (bin) => {
      if (!capacityAnalysisBins.some((item) => item.bin_id == bin["bin_id"])) {
        this.clusterBins.push(bin);
      }
    });
    this.clusterBins = this.clusterBins.concat(capacityAnalysisBins);
    this.openClusterInfoPopup();
  }

  openClusterInfoPopup() {
    let class_name = '';
    if(this.isMobile){
      class_name = 'popup-container-mobile';
    }else{
      class_name = this.currentLang != "iw" ? "clusterInfo-container-ltr" : "clusterInfo-container-rtl";
    }

    this.dialog.open(CollectionClusterInfoModal, {
      panelClass: class_name,
      data: {
        items: this.clusterBins
      },
    });
  }

  changeSubmitClickedStatus(el) {
    this.openClusterInfo(el);
  }
   
  onPageChange = (dataTableIndexes: any) => {
		this.startIndexTableData = dataTableIndexes.startIndex;
		this.endIndexTableData = dataTableIndexes.endIndex;
		this.updateTableData();
  }

  getProgressBarStyleInternalCollections = (el,value: any) => {
    let element = el;    
		if (value <= element.green_status_value) {
			return { 'background-color': '#14C264', 'width': value + '%','max-width':'100%' };
		} else if (value > element.green_status_value && value <= element.yellow_status_value) {
			return { 'background-color': '#FAB300', 'width': value + '%','max-width':'100%' };
		}
		return { 'background-color': '#E01B09', 'width': value + '%','max-width':'100%' };
  }

  removeFilter(){	
    this.groups = this.groupsBackup;	
    this.initTableData(this.groups);																				
  }

  getArrayOfCollections(group:any){   
    const binsFiltered = _.map(group, b => {
      return {
        bin_name: b["bin_name"],
        is_suspected_collection_csv:'',
        site_name:b["site_name"],
        bin_address: b["bin_address"],
        bin_collection_time: this.utilService.convertDateEnglish(b["bin_collection_time"]),
        collected_driver_arrival_time: this.utilService.convertDateEnglish((b["collected_driver_Arrival_time"] ?? b["collected_driver_arrival_time"])),
        collection_cause_name: b["collection_cause_name"],
        suspected_reason_name: b["is_suspected_collection"] == null ? b["suspected_reason_name"] : '',
        removed_by_name: b["is_suspected_collection"] == null && b["is_suspected_as_collection_event"] == null ? `${b["approved_by_user_first_name"] ?? ''} ${b["approved_by_user_last_name"] ?? ''}`.trim() : '',
        removed_date: b["is_suspected_collection"] == null && b["is_suspected_as_collection_event"] == null ? this.utilService.convertDateEnglish(b["approval_date"]) : '',
        suspected_reason_name_for_suspicious_collection: b["is_suspected_collection"] == 1 ? b["suspected_reason_name"] : (b["is_approved_suspected_as_collection_event"] == false && b["is_deleted_suspected_as_collection_event"] != true) ? b["suspected_as_collection_event_reason_name"] : '',        
        bin_fill_level_before_collection: b["bin_fill_level_before_collection"],
        bin_fill_level_after_collection: b["bin_fill_level_after_collection"],
        is_part_of_work_plan_csv:'',
        neighborhood:b["bin_neighbourhood"],
        event_type: b["event_type"],
        collection_id: b["collection_id"],
        collection_cause_name_hebrew : b["collection_cause_name_hebrew"],
        bin_avg_fill_rate: b["bin_avg_fill_rate"],
        collected_driver_first_name: b["collected_driver_first_name"],
        collected_driver_last_name: b["collected_driver_last_name"],
        assigned_truck_license_plate: b["assigned_truck_license_plate"],
        bin_id: b["bin_id"],
        green_status_value: b["green_status_value"],
        yellow_status_value: b["yellow_status_value"],
        number_of_bins_in_cluster: b["number_of_bins_in_cluster"],
        chosenCluster: b["chosenCluster"],
        site_id: b["site_id"],
        cluster_id: b["cluster_id"],
        cluster_avg: b["cluster_avg"],
        bin_collection_time_he : this.utilService.convertDateHebrew(b["bin_collection_time"]),
        collected_driver_arrival_time_he: this.utilService.convertDateHebrew((b["collected_driver_Arrival_time"] ?? b["collected_driver_arrival_time"])),
        is_suspected_collection: b["is_suspected_collection"],
        is_part_of_work_plan: b["is_part_of_work_plan"],
        suspected_reason_name_hebrew: b["is_suspected_collection"] == null ? b["suspected_reason_name_hebrew"] : '',
        suspected_reason_name_for_suspicious_collection_hebrew: b["is_suspected_collection"] == 1 ? b["suspected_reason_name_hebrew"] : (b["is_approved_suspected_as_collection_event"] == false && b["is_deleted_suspected_as_collection_event"] != true) ? b["suspected_as_collection_event_reason_name_hebrew"] : '',        
        is_approved_suspected_as_collection_event: b["is_approved_suspected_as_collection_event"],
        is_suspected_as_collection_event: b["is_suspected_as_collection_event"],
        is_deleted_suspected_as_collection_event: b["is_deleted_suspected_as_collection_event"],
        transaction_id: b["transaction_id"],
        after_collection_transaction_id: b["after_collection_transaction_id"],
        approval_date: b["is_suspected_collection"] == null && b["is_suspected_as_collection_event"] == null ? b["approval_date"] : '',
        removed_date_he: b["is_suspected_collection"] == null && b["is_suspected_as_collection_event"] == null ? this.utilService.convertDateHebrew(b["approval_date"]) : ''
      };
    });
    return binsFiltered;
  }

  parseDateFormat(dateStr){
		return this.currentLang == 'iw' ? this.utilService.convertDateHebrew(dateStr) : this.utilService.convertDateEnglish(dateStr);
	}

  openAddCollectionModal = () => {	
    let class_name = '';
    if(this.isMobile){
      class_name = 'popup-container-mobile';
    }else{
      class_name = 'bulkBins-container';
    }
    this.dialog.open(AddCollectionModal, { panelClass: class_name });	
  }

  exportToCsv = () => {
		let dataToExport = null;
		if (this.selection.selected.length > 0) {
			dataToExport = _.cloneDeep(this.selection.selected);
		} else {
			dataToExport = _.cloneDeep(this.filteredData);
		}

    _.each(dataToExport, (item) => {
      if(this.currentLang == 'iw'){
        item.bin_collection_time = item.bin_collection_time_he;
        item.collected_driver_arrival_time = item.collected_driver_arrival_time_he;
        item.collection_cause_name = item.collection_cause_name_hebrew;
        item.suspected_reason_name = item.suspected_reason_name_hebrew;
        item.suspected_reason_name_for_suspicious_collection = item.suspected_reason_name_for_suspicious_collection_hebrew;
        item.removed_date = item.removed_date_he;
      }
      item.is_suspected_collection_csv = this.getEventTypeLabel(item);
      if (!this.isDeletedCollection(item)) {
        item.suspected_reason_name = '';
      }
      item.is_part_of_work_plan_csv = item.is_part_of_work_plan ? this.translationsObj.MANAGE_BIN.INCLUDE_IN_WORKPLAN : this.translationsObj.MANAGE_BIN.NOT_INCLUDE_IN_WORKPLAN;
    });

		const header = 
		{
			'0' : this.translationsObj.SITE_MANAGMENT.BIN_NAME, 
			'1' : this.translationsObj.TICKET_MANAGEMENT.EVENT_TYPE,
			'2' : this.translationsObj.TRUCK_MAP.SITE,
			'3' : this.translationsObj.LIST_COLUMNS.ADDRESS, 
			'4' : this.translationsObj.LIVE_INFO.LIST_COLLECTION_TIME,
			'5' : this.translationsObj.COLLECTION_REPORT.ARRIVAL_TIME,
			'6' : this.translationsObj.TITLES.COLLECTION_CAUSE,
			'7' : this.translationsObj.TICKET_MANAGEMENT.REMOVED_REASON,
			'8' : this.translationsObj.TICKET_MANAGEMENT.REMOVED_BY,
			'9' : this.translationsObj.TICKET_MANAGEMENT.REMOVED_DATE,
			'10' : this.translationsObj.TITLES.SUSPICION_REASON,
			'11' : this.translationsObj.COLLECTION_REPORT.PRE_PICKUP_CSV,
			'12' : this.translationsObj.COLLECTION_REPORT.POST_PICKUP_CSV,
			'13' : this.translationsObj.MANAGE_BIN.INCLUDE_IN_WORKPLAN
		}

		const flatData = dataToExport.reduce((b, a) => {	
			let res = _.slice(_.values(a), 0, Object.keys(header).length)									
			b.push(res);
			return b;
		}, [])

		let source:any = {
			flatData,
			header
		};	

		let result = source.flatData.map((details:any) => 
		Object.keys(details).reduce((a:any, b:any) => 
		(a[source.header[b]] = details[b], a), {}));			
		if(this.currentLang != 'iw'){
			TableUtil.exportArrayToExcel(result, "Collections");
		}else{
			TableUtil.exportArrayToExcel(result, "פינויים");
		}
	}

  private isDeletedCollection(item: any): boolean {
    return item["is_suspected_collection"] == null && item["is_suspected_as_collection_event"] == null;
  }

  /** Event type label for the export, mirroring the evType column's branches and their order. */
  private getEventTypeLabel(item: any): string {
    const labels = this.translationsObj.COLLECTION_REPORT;
    if (item["is_suspected_collection"] == 0) {
      return labels.REGISTERED_COLLECTION_SINGULAR;
    }
    if (item["is_suspected_collection"] == 1) {
      return labels.SUSPICIOUS_COLLECTION_SINGULAR;
    }
    if (this.isDeletedCollection(item)) {
      return labels.DELETED_COLLECTION_SINGULAR;
    }
    if (item["is_approved_suspected_as_collection_event"] == false && item["is_deleted_suspected_as_collection_event"] != true) {
      return labels.INVALID_COLLECTION_SINGULAR;
    }
    return '';
  }

  getSiteCollectionCount(siteId: number,binCollectionTime: string): number {
    return this.groupsBackup.filter(item => item.is_suspected_collection != null && item.site_id === siteId && moment(item.bin_collection_time).isSame(moment(binCollectionTime),'day')).length;
  }
}
